import script from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=019d8339&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019d8339"]])

export default __exports__